export enum NavItemMenuGroupTypesEnum {
  usersAndRoles = 'usersAndRoles',
  usersAndRolesForPracticeOwn = 'usersAndRolesForPracticeOwn',
  questionsAndConsult = 'questionsAndConsult',
  questionsAndConsultProviderRole = 'questionsAndConsultProviderRole',
  announcementsAndReleaseNotes = 'announcementsAndReleaseNotes',
  providersAndDevices = 'providersAndDevices',
}
